import React, { useEffect, useMemo, useRef, useState } from 'react';

import { sportService } from 'common/constants';

import { LiveCenterWidget } from './LiveCenterWidget';

const { LIVE } = sportService;

const LiveCenter = ({ event }) => {
  const [fixed, setFixed] = useState(false);

  const { id, info, sportService, widgets } = event;

  const tabsRef = useRef(null);

  const intersectionObserver = useRef(
    new IntersectionObserver(([entry]) => {
      setFixed(!entry.isIntersecting);
    }),
  );

  const isLiveCenter = useMemo(
    () => widgets?.some(widget => widget.type === 'SCORE_BOARD'),
    [widgets],
  );

  const isLive = sportService === LIVE;

  const widgetsData = useMemo(() => {
    if (widgets?.length > 0) {
      return {
        id,
        isActive: true,
        liveStatus: info.score.liveStatus,
        widgets,
      };
    }
  }, [id, info.score.liveStatus, widgets]);

  useEffect(() => {
    if (tabsRef.current) {
      intersectionObserver.current.observe(tabsRef.current);
    }
  }, []);

  if (!widgets || !isLive || widgets.length < 1) {
    return null;
  }

  return (
    <div className="absolute-widgets">
      <div ref={tabsRef}>
        {isLiveCenter && <LiveCenterWidget fixed={fixed} widgetsData={widgetsData} />}
      </div>
    </div>
  );
};

export default LiveCenter;
